import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.ts';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { borderRadius, space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.ts';
import { style } from '@vanilla-extract/css';
import {
  containerMaxWidth,
  containerPadding,
  containerPaddingMobile,
} from './style-vars';
import { buttonsBox } from '../_auth.auth.signup/setup-MFA-form.css';

export const header = style([
  {
    display: 'flex',
    justifyContent: 'space-between',
    pointerEvents: 'none',
  },
  responsiveStyle({
    mobile: {
      position: 'relative',
      width: `100%`,
      margin: `${space.s12}px 0 0`,
      alignItems: 'center',
    },
    tablet: {},
    laptop: {
      position: 'absolute',
      width: `calc(100% - ${containerPadding * 2}px)`,
      margin: `${containerPadding}px ${containerPadding}px 0`,
      alignItems: 'start',
    },
  }),
]);

export const welcomeContainer = style([
  {
    minHeight: '100vh',
    display: 'grid',
    gap: space.s32,
    position: 'relative',
    maxWidth: containerMaxWidth,
    margin: '0 auto',
  },
  responsiveStyle({
    mobile: {
      gridTemplateRows: 'auto auto 1fr',
      gridTemplateColumns: '100%',
      padding: containerPaddingMobile,
      flexDirection: 'column',
    },
    tablet: {},
    laptop: {
      gridTemplateRows: '1fr',
      gridTemplateColumns: '1fr 1fr',
      padding: containerPadding,
      flexDirection: 'row',
    },
  }),
]);

export const welcomeGradient = style([
  {
    background: 'white',
    backgroundImage: 'url(./media/bg-gradient-1.svg)',
    backgroundRepeat: 'no-repeat',
    backgroundPositionX: 'right',
  },
  responsiveStyle({
    mobile: {
      backgroundSize: 'unset',
    },
    tablet: {},
    laptop: {
      backgroundSize: 'contain',
    },
  }),
]);

export const welcomeCard = style([
  {
    display: 'flex',
    flexDirection: 'column',
  },
]);

export const contentBlock = style([
  {
    display: 'flex',
    flexDirection: 'column',
  },
]);

export const cardBody = style([
  typography.bodyMd,
  {
    color: themeVars.container.foreground.secondary,
  },
]);

export const waitlistCard = style([
  {
    selectors: {
      '&:is(&)': {
        borderRadius: borderRadius.r25,
        justifyContent: 'center',
        padding: space.s20,
        width: '100%',
      },
    },
  },
]);

export const cardHeading = style([
  typography.headlineSm,
  responsiveStyle({
    mobile: {
      marginBottom: 0,
    },
    tablet: {},
    laptop: {
      marginBottom: space.s12,
    },
  }),
]);

export const authCard = style([
  waitlistCard,
  {
    position: 'relative',
    height: 'fit-content',
  },
  responsiveStyle({
    mobile: {
      margin: `auto auto ${space.s10}px`,
      maxWidth: '100%',
    },
    tablet: {},
    laptop: {
      margin: 'auto',
      maxWidth: 610,
      selectors: {
        '&:is(&)': {
          padding: `${space.s64}px ${space.s20}px`,
        },
      },
    },
  }),
]);

export const authContent = style({
  margin: '0 auto',
  maxWidth: 416,
  width: '100%',
});

export const formFieldsContainer = style([
  {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: `${space.s8}px`,
    margin: `${space.s20}px 0`,
  },
]);

export const formHeading = style([
  cardHeading,
  responsiveStyle({
    mobile: {
      ...typography.titleLg,
      marginBottom: space.s6,
    },
    tablet: {
      ...typography.headlineSm,
    },
  }),
]);

export const submitAuthFormButton = style([
  {
    marginTop: `${space.s14}px`,

    selectors: {
      [`${buttonsBox} &`]: {
        marginTop: 0,
      },
    },
  },
]);

export const actionLinkBlock = style([
  {
    textAlign: 'center',
  },
]);

export const actionLink = style([
  typography.bodyMd,
  {
    color: themeVars.link.idle,
    ':hover': {
      textDecoration: 'underline',
    },
  },
]);

export const actionLinkButton = style([
  {
    color: themeVars.color.bgFill.interactive.primary.active,
  },
]);

export const checkbox = style([
  typography.bodyMd,
  {
    display: 'flex',
    gap: space.s8,
    marginTop: space.s6,
    color: themeVars.container.foreground.tertiary,
  },
]);

export const subButton = style([typography.bodyMd]);

export const spinner = style({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
});

export const footerContainer = style([
  {
    width: '100%',
  },
  responsiveStyle({
    mobile: {
      position: 'relative',

      selectors: {
        '&:is(&)': {
          padding: 0,
        },
      },
    },
    tablet: {},
    laptop: {
      position: 'absolute',
      bottom: 0,

      selectors: {
        '&:is(&)': {
          padding: `${space.s20}px ${space.s60}px`,
        },
      },
    },
  }),
]);
